import { colors } from 'utils/colors'
import { Text } from 'components/Typography'
import { Trans, useTranslation } from 'next-i18next'
import Link from 'next/link'

export const PromoCodeNotFound = () => {
  const { t } = useTranslation('entrance')
  return (
    <div
      css={{
        padding: '1rem',
        backgroundColor: colors.red[100],
        borderRadius: '0.25rem',
      }}
    >
      <Text variant="bodySmall">
        <Trans
          t={t}
          i18nKey="entrance.signup.invalid_promocode"
          components={[
            <Link
              href="https://myaccount.aol.com/manage/aol-plans"
              css={{ color: 'inherit' }}
              key={0}
            />,
            <Link href="https://help.aol.com/" css={{ color: 'inherit' }} key={1} />,
          ]}
        />
      </Text>
    </div>
  )
}

export const PromoCodeIsUsed = () => {
  const { t } = useTranslation('entrance')
  return (
    <div
      css={{
        padding: '1rem',
        backgroundColor: colors.red[100],
        borderRadius: '0.25rem',
      }}
    >
      <Text variant="bodySmall">
        <Trans
          t={t}
          i18nKey="entrance.signup.used_promocode"
          components={[
            <Link href="/login" css={{ color: 'inherit' }} key={0} />,
            <Link href="https://help.aol.com/" css={{ color: 'inherit' }} key={1} />,
          ]}
        />
      </Text>
    </div>
  )
}
